import { css } from "emotion"

export const headerCont = css`
  height: 100%;
  background: var(--dark-blue);
  width: calc(100% - 40px);
  padding: 0 20px 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: solid 1px #0002;
  color: #fff;
`

export const avatar = css`
  cursor: pointer;
  background: transparent;
  color: #000;
`
export const popOverIcon = css`
  font-size: 13px;
  width: 25px;
  height: 25px;
`

export const optionClass = css`
  display: flex;
  align-items: center;
  width: 120px;
  color: #000;
  border: none;
`
export const imgClass = css`
  width: 30px;
  height: 30px;
  outline: none;
`
export const infoClass = css`
  margin-left: 7.5px;
  font-size: 15px;
`
